/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{margin-top:10vh}.vertical-text[_ngcontent-%COMP%]{margin:0;position:fixed;font-size:13vh!important;right:-3vh;bottom:0;-webkit-writing-mode:vertical-rl;-ms-writing-mode:tb-rl;writing-mode:vertical-rl;-webkit-transform:rotate(180deg);transform:rotate(180deg);font-weight:bolder;color:rgba(128,128,128,.5)}"];
export { styles as styles };
